import {
  LayoutDashboard,
  Clock,
} from 'lucide-react';
import type { NavItem, Tenant } from './types';
import { NavCategory } from './types';

export const CURRENT_TENANT: Tenant = {
  id: 't-001',
  name: 'Nebula Industries',
  logo: 'https://picsum.photos/40/40',
  primaryColor: '217 91% 60%'
};

export const NAV_ITEMS: NavItem[] = [
  // General / Pinned
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, category: NavCategory.GENERAL },

  // People
  { id: 'timekeeping', label: 'Timekeeping', icon: Clock, category: NavCategory.PEOPLE },

];

export const CATEGORY_ORDER = [
  NavCategory.PEOPLE,
];